import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { FaSpinner } from 'react-icons/fa6';
import Select from "react-select";
import { toast } from 'react-toastify';

const ReqInputForm = ({
    issueDate,
    setIssueDate,
    costCenterOptions,
    selectedCostCenter,
    setSelectedCostCenter,
    loadingCC,
    selectedOutlet,
    itemOptions,
    itemData,
    handleItemChange,
    handleQuantityChange,
    error,
    setError,
    editingIndex,
    setEditingIndex,
    setItemData,
    handleAdd,
    INITIAL_ITEM,
    editableClass,
    readonlyClass,
    selectStyles,
    baseUrl,
    token,
    fetchCostCenters,
    errorCC
}) => {
    const [showCCModal, setShowCCModal] = useState(false);
    const [ccModalError, setCCModalError] = useState(false);
    const [newCostCenters, setNewCostCenters] = useState([""]);
    const [creating, setCreating] = useState(false);

    const filteredItemOptions =
        selectedCostCenter?.value === "Central Kitchen"
            ? itemOptions.filter(
                (item) => item.GroupName !== "Finished Goods"
            )
            : itemOptions;

    return (
        <>
            <div className="grid grid-cols-3 gap-y-3 gap-x-2 mb-4 w-1/3 content-start">
                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Issue Date *</label>
                <input
                    type="date"
                    value={issueDate}
                    onChange={(e) => setIssueDate(e.target.value)}
                    className={readonlyClass}
                    readOnly
                    required
                />

                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Cost Center *</label>
                <div className="col-span-2 text-sm">
                    {loadingCC ? (
                        <div className="flex items-center gap-2 p-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500">
                            <FaSpinner className="animate-spin text-blue-500 text-sm" />
                            <span className="text-sm">Loading cost centers...</span>
                        </div>
                    ) : errorCC ? (
                        <p className="col-span-3 text-red-500 text-sm">{errorCC}</p>
                    ) : (
                        <Select
                            options={costCenterOptions}
                            value={selectedCostCenter}
                            placeholder="Select cost center"
                            onChange={(option) => setSelectedCostCenter(option)}
                            styles={selectStyles}
                            isDisabled={!selectedOutlet}
                            isSearchable
                            isClearable
                        />
                    )}
                </div>

                <div className='col-span-3 flex justify-end'>
                    <button
                        onClick={() => setShowCCModal(true)}
                        className='bg-gradient-to-r from-emerald-500 to-emerald-700 text-white px-3 py-1.5 text-xs font-semibold rounded-md transition hover:scale-[1.02] hover:shadow-lg active:scale-95'
                    >
                        Create New Cost Center
                    </button>
                </div>

                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Select Item</label>
                <div className="col-span-2 text-sm">
                    <Select
                        options={filteredItemOptions}
                        value={
                            itemData.ItemName
                                ? {
                                    label: itemData.ItemName,
                                    value: itemData.ItemName
                                }
                                : null
                        }
                        onChange={handleItemChange}
                        placeholder="Search item..."
                        styles={selectStyles}
                        isSearchable
                        isClearable
                    />
                </div>

                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Group</label>
                <input
                    value={itemData.GroupName}
                    readOnly
                    className={readonlyClass}
                />

                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">UOM</label>
                <input
                    value={itemData.UOM}
                    readOnly
                    className={readonlyClass}
                />

                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Rate</label>
                <input
                    value={itemData.Rate}
                    readOnly
                    className={readonlyClass}
                />

                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Stock Level</label>
                <input
                    value={itemData.CurrentLevel}
                    readOnly
                    className={readonlyClass}
                />

                <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Issue Quantity *</label>
                <input
                    type="number"
                    placeholder="Enter Quantity"
                    value={itemData.Quantity}
                    onChange={handleQuantityChange}
                    className={editableClass}
                    step="any"
                />

                {error && <p className="col-span-3 text-red-500 text-sm">{error}</p>}

                <div className="col-span-3 flex items-center gap-2 justify-end mt-1">
                    {editingIndex !== null && (
                        <button
                            onClick={() => {
                                setItemData(INITIAL_ITEM);
                                setEditingIndex(null);
                                setError("");
                            }}
                            className="px-4 py-1.5 text-sm bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-1 focus:ring-gray-500 transition-colors"
                        >
                            Cancel Edit
                        </button>
                    )}
                    <button
                        onClick={handleAdd}
                        className="px-4 py-1.5 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors"
                    >
                        {editingIndex !== null ? "Update Item" : "Add Item to List"}
                    </button>
                </div>
            </div>

            {showCCModal && (
                <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-[400px] p-4">
                        <h3 className="text-sm font-semibold mb-3">Create Cost Centers</h3>

                        <div className="space-y-2 max-h-[250px] overflow-auto tiny-scrollbar">
                            {newCostCenters.map((cc, index) => (
                                <div key={index} className="flex gap-2">
                                    <input
                                        value={cc}
                                        onChange={(e) => {
                                            const updated = [...newCostCenters];
                                            updated[index] = e.target.value;
                                            setNewCostCenters(updated);

                                            if (ccModalError) setCCModalError("");
                                        }}
                                        placeholder="Enter cost center"
                                        className="flex-1 px-2 py-1 border rounded-md text-sm"
                                    />

                                    <button
                                        disabled={newCostCenters.length === 1}
                                        onClick={() => {
                                            if (newCostCenters.length === 1) return;
                                            setNewCostCenters(prev => prev.filter((_, i) => i !== index));
                                        }}
                                        className={`text-sm ${newCostCenters.length === 1
                                            ? "text-gray-300 cursor-not-allowed"
                                            : "text-red-500"
                                            }`}
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                        </div>

                        {ccModalError && <p className="text-red-500 text-sm">{ccModalError}</p>}

                        {/* Add more */}
                        <button
                            onClick={() => {
                                const last = newCostCenters[newCostCenters.length - 1];

                                if (!last || last.trim() === "") {
                                    setCCModalError("Fill current field before adding another");
                                    return;
                                }

                                setNewCostCenters(prev => [...prev, ""]);
                                setCCModalError("");
                            }}
                            className="mt-2 text-sm text-blue-600"
                        >
                            + Add another
                        </button>

                        {/* Actions */}
                        <div className="flex justify-end gap-2 mt-4">
                            <button
                                onClick={() => {
                                    setShowCCModal(false);
                                    setNewCostCenters([""]);
                                }}
                                className="px-3 py-1 text-sm bg-gray-400 text-white rounded"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={async () => {
                                    if (!selectedOutlet) {
                                        return setCCModalError("Select outlet first");
                                    }

                                    const existing = costCenterOptions.map(c => c.value.toLowerCase());

                                    const filtered = newCostCenters
                                        .map(c => c.trim())
                                        .filter(c => c !== "");

                                    if (filtered.length === 0) {
                                        return setCCModalError("Enter at least one cost center");
                                    }

                                    const unique = new Set(filtered.map(c => c.toLowerCase()));
                                    if (unique.size !== filtered.length) {
                                        return setCCModalError("Duplicate entries in list");
                                    }

                                    const duplicates = filtered.filter(c =>
                                        existing.includes(c.toLowerCase())
                                    );

                                    if (duplicates.length > 0) {
                                        return setCCModalError(`Already exists: ${duplicates.join(", ")}`);
                                    }

                                    try {
                                        setCreating(true);

                                        for (const cc of filtered) {
                                            await axios.post(`${baseUrl}/create_costcenter`, {
                                                token,
                                                costcenter_name: cc,
                                                outlet_name: selectedOutlet
                                            });
                                        }

                                        toast.success("Cost centers created");

                                        setSelectedCostCenter(null);
                                        setShowCCModal(false);
                                        setNewCostCenters([""]);
                                        fetchCostCenters();

                                    } catch (error) {
                                        console.error(error);
                                        toast.error(error.response?.data?.error || error.response?.data?.message || error.message || "Failed to create cost centers");
                                    } finally {
                                        setCreating(false);
                                    }
                                }}
                                className="px-3 py-1 text-sm bg-green-600 text-white rounded"
                                disabled={creating}
                            >
                                {creating ? "Creating..." : "Create"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ReqInputForm